import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { withFlavourCSS } from '@xingternal/flavour';

import { base, odl, xdl } from './flavours';
import NavItem from './NavItem';

// move to utils
const arrayFill = d => Array(d).fill();

const NavList = ({
  main,
  activeItem,
  placeholders,
  notifications,
  hasUser,
  items,
  styles,
}) => {
  const listClass = main ? styles.main : styles.other;
  return (
    <ul className={cx(listClass)}>
      {hasUser
        ? items.map(item => (
            <NavItem
              meta={item}
              key={item.key}
              notificationCount={
                notifications && notifications[item.notificationKey || '']
              }
              isActive={item.key === activeItem}
              hasUser={hasUser}
            />
          ))
        : arrayFill(placeholders).map((_, index) => (
            <NavItem hasUser={false} key={index} />
          ))}
    </ul>
  );
};

NavList.propTypes = {
  main: PropTypes.bool,
  activeItem: PropTypes.string,
  placeholders: PropTypes.number,
  hasUser: PropTypes.bool,
  notifications: PropTypes.object,
  items: PropTypes.array,
  styles: PropTypes.object.isRequired,
};
NavList.defaultProps = {
  main: false,
  items: [],
};

export { NavList };
export default withFlavourCSS(base, { xdl, odl })(NavList);
